import { clone, isFunction } from 'lodash'

import type { MutationOptions } from '@apollo/client/core';
import { ApolloClient } from '@apollo/client/core';
import { MutationUpdaterFunction } from '@apollo/client/core/types';

export function mutate(client: ApolloClient<any>, mutation, variables: Record<string, any>, optionsOrUpdateFunction: MutationOptions|MutationUpdaterFunction<any, any, any, any>) {

    let options: Partial<MutationOptions> = {};

    if(isFunction(optionsOrUpdateFunction)){
        options.update = optionsOrUpdateFunction;
    }
    else if(optionsOrUpdateFunction){
        options = clone(optionsOrUpdateFunction);
    }

    return client.mutate({

        mutation,
        variables,

        ...options
    });
}